import React from 'react';

import { EarningsPerCountry } from '@trqk/components';
import { locale } from '@trqk/utils';

interface EarningsRegionsProps {
    id: string;
    height: number;
    countryCodes: ProCountryCode[];
}

export const EarningRegions = ({
    id,
    height,
    countryCodes,
}: EarningsRegionsProps): JSX.Element => (
    <div className="bg-white rounded-lg">
        <div className="p-6">
            <h4>{locale.enUS.STATEMENTS.SECTIONS.REGIONS.CONTENT_TITLE}</h4>
            <EarningsPerCountry
                chartDivId={`${id}.earnings-per-country`}
                chartHeight={height * (4 / 5)}
                countryCodes={countryCodes}
                legendHeight={height * (1 / 5)}
            />
        </div>
    </div>
);
